<template>
  <div v-if="showNotification" class="progressive-notification">
    <div class="notification-content">
      <div class="notification-icon">
        <i class="fas fa-info-circle"></i>
      </div>
      <div class="notification-text">
        <h6>Progressive Loading Activated</h6>
        <p>
          Range of more than 2 months detected. Data will be loaded progressively 
          month by month to improve performance.
        </p>
      </div>
      <div class="notification-close">
        <button @click="closeNotification" class="close-btn">
          <i class="fas fa-times"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProgressiveNotification',
  props: {
    showNotification: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    closeNotification() {
      this.$emit('close');
    }
  }
}
</script>

<style lang="scss" scoped>
.progressive-notification {
  position: fixed;
  top: 20px;
  right: 20px;
  max-width: 400px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-radius: 12px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  animation: slideIn 0.3s ease-out;
}

@keyframes slideIn {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

.notification-content {
  display: flex;
  align-items: flex-start;
  padding: 1rem;
  gap: 0.75rem;
}

.notification-icon {
  flex-shrink: 0;
  font-size: 1.25rem;
  color: rgba(255, 255, 255, 0.9);
  margin-top: 0.125rem;
}

.notification-text {
  flex: 1;
  
  h6 {
    margin: 0 0 0.5rem 0;
    font-weight: 600;
    font-size: 0.95rem;
  }
  
  p {
    margin: 0;
    font-size: 0.85rem;
    line-height: 1.4;
    opacity: 0.9;
  }
}

.notification-close {
  flex-shrink: 0;
}

.close-btn {
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.875rem;
  cursor: pointer;
  padding: 0.25rem;
  border-radius: 4px;
  transition: all 0.2s ease;
  
  &:hover {
    color: white;
    background: rgba(255, 255, 255, 0.1);
  }
}

// Responsive improvements
@media (max-width: 576px) {
  .progressive-notification {
    top: 10px;
    right: 10px;
    left: 10px;
    max-width: none;
    border-radius: 8px;
  }
  
  .notification-content {
    padding: 0.75rem;
  }
  
  .notification-text h6 {
    font-size: 0.9rem;
  }
  
  .notification-text p {
    font-size: 0.8rem;
  }
  
  .notification-icon {
    font-size: 1.1rem;
  }
}

@media (max-width: 480px) {
  .progressive-notification {
    top: 5px;
    right: 5px;
    left: 5px;
  }
  
  .notification-content {
    padding: 0.5rem;
  }
  
  .notification-text h6 {
    font-size: 0.85rem;
    margin-bottom: 0.25rem;
  }
  
  .notification-text p {
    font-size: 0.75rem;
    line-height: 1.3;
  }
  
  .notification-icon {
    font-size: 1rem;
  }
  
  .close-btn {
    font-size: 0.8rem;
    padding: 0.2rem;
  }
}

// Landscape orientation on mobile
@media (max-width: 767px) and (orientation: landscape) {
  .progressive-notification {
    top: 5px;
    right: 15px;
    left: 15px;
    max-width: none;
  }
  
  .notification-content {
    padding: 0.5rem;
  }
  
  .notification-text h6 {
    font-size: 0.85rem;
    margin-bottom: 0.25rem;
  }
  
  .notification-text p {
    font-size: 0.75rem;
  }
}

// Ensure notification is visible on very small screens
@media (max-width: 360px) {
  .progressive-notification {
    top: 5px;
    right: 5px;
    left: 5px;
  }
  
  .notification-content {
    padding: 0.5rem;
    gap: 0.5rem;
  }
  
  .notification-text h6 {
    font-size: 0.8rem;
  }
  
  .notification-text p {
    font-size: 0.7rem;
  }
}
</style> 